import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement} from 'lit';
import stylesheet from './x-address.scss?as=stylesheet';

export class Address extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {};
	}

	constructor () {
		super();
	}

	render () {
		return html`
			<address>
				<div class="name">
					<slot name="first-name"></slot>
					<slot name="last-name"></slot>
				</div>

				<div class="address">
					<slot name="address"></slot>
				</div>

				<div class="locality">
					<slot name="city"></slot> <slot name="state"></slot> <slot name="zip"></slot>, <slot name="country"></slot>
				</div>
			</address>
		`;
	}
};

defineCustomElement('x-address', Address);
